require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./nostalgic-about-cat-with-bow-golf.json") })
        }
      }, "path---nostalgic-about-cat-with-bow-golf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---nostalgic-about-cat-with-bow-golf!./.cache/json/nostalgic-about-cat-with-bow-golf.json
// module id = 538
// module chunks = 231608221292675